import React, { useState } from "react";
import './BulkUploadMain.scss';
import { assetEditService } from "api/assetEditService";
import Loading from "components/Placeholders/Loading";
import { isEmpty } from "lodash-es";
import AlertBox from "componentsV2/SharedAlertBox/AlertBox/AlertBox";

interface BulkUploadInfoProps {
  defaults?: any
}

const BulkUploadInfo: React.FC<BulkUploadInfoProps> = ({ defaults }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({open: false, message:''});

  const handleDownloadTemplate = async () => {
    if(isEmpty(defaults)){
      setAlert({open: true, message :"Please select the asset type to proceed"});
    }
    const path = defaults?.template_path || '';
    //path split by / and get the last part
    const fileName = path.split('/').pop() || `${defaults?.model_name}.xlsx`;
    setIsLoading(true);
    try {
      const response = await assetEditService.getPresignedUrl(path);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      const fileResponse = await fetch(data.success.preSignedURL);
      if (!fileResponse.ok) {
        throw new Error('Failed to fetch the file');
      }
      const blob = await fileResponse.blob();
      // Create a temporary link element to trigger the download
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.href = url;
      // Set the download attribute to specify the file name
      link.download = fileName;
      link.click();
      // Revoke the object URL to free up memory
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error fetching presigned URL:', error);
    }
    finally{
      setIsLoading(false);
    }
  };

  const handleScrollToGuidelines = () => {
    const guidelinesElement = document.getElementsByClassName('job-name');
    if (guidelinesElement) {
      guidelinesElement[0].scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <div className="bulk-upload-requirements-compact">
      {isLoading && <Loading/>}
      {alert.open && <AlertBox isModalOpen={alert.open} message={alert.message} handleClose={() => setAlert({open: false, message: ''})}/>}
      <h3 className="requirements-title-compact">Upload Requirements</h3>
      <ul className="requirements-list">
        <li className="requirement-item">
          <span className="req-icon-small icon-16-docs-exe-mono"></span>
          <strong>Template:</strong> Use the{' '}
          <span
            className={`link-button`}
            onClick={handleDownloadTemplate}
          >
            {'downloadable template'}
          </span>
          {' '}for proper Excel format.
        </li>
        <li className="requirement-item">
          <span className="req-icon-small icon-16-folder-open-mono"></span>
          <strong>File Info:</strong> Excel (.xlsx) or ZIP (.zip). Max size for zip file is 20MB.
        </li>
        <li className="requirement-item">
          <span className="req-icon-small icon-16-info-mono"></span>
          <strong>Guidelines:</strong> Kindly review{' '}
          <span
            className={`link-button`}
            onClick={handleScrollToGuidelines}
          >
            {'guidelines'}
          </span>
          {' '}before starting.
        </li>
      </ul>
    </div>
  );
};

export default BulkUploadInfo;